
import styles from "./styles.module.scss";
import { HubLayoutSection } from "src/types/hub";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';
import { ChangeEvent, useEffect, useState } from "react";
import { AutoGrowInput } from "src/components/input";
import cx from "classnames";

interface SectionItemProps {
  sectionId: any;
  section: HubLayoutSection;
  selected: boolean;
  isRemovable: boolean;
  // eslint-disable-next-line no-unused-vars
  onClick: () => void;
  // eslint-disable-next-line no-unused-vars
  onRemove: () => void;
  // eslint-disable-next-line no-unused-vars
  onNameChange: (value: string) => void;
}


export const SectionTab: React.FC<SectionItemProps> = ({
  sectionId,
  section,
  selected,
  isRemovable,
  onClick,
  onNameChange,
  onRemove,
}) => {
  console.log("SectionItem render:", section, selected);
  const [originalName, setOriginalName] = useState(section.title);

  const { transform, transition, attributes, listeners, setNodeRef, isDragging } = useSortable({
    id: sectionId,
    data: {
      section: section,
      type: "section"
    },
  });

  useEffect(() => {
    setOriginalName(section.title);
  }, []);

  const handleNameChange = (e: ChangeEvent<HTMLInputElement>) => {
     e.stopPropagation();
     onNameChange(e.target.value);
  };

  const handleRemove = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onRemove();
  };

  const style = {
    transform: CSS.Transform.toString({
      x: transform?.x ?? 0,
      y: transform?.y ?? 0,
      scaleX: 1,
      scaleY: 1,
    }),
    transition,
  };

  return (
    <div
      style={style}
      className={cx(styles.section, "collection_section", {
        [styles.selected]: selected,
        [styles.dragging]: isDragging,
        [styles.removable]: isRemovable,
      })}
      ref={setNodeRef}
      data-section-id={section.tempId}
      {...listeners}
      {...attributes}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <AutoGrowInput
        readOnly={!selected}
        className={styles.input}
        placeholder={originalName}
        maxWidth={1000}
        value={section.title}
        onChange={handleNameChange}
      />

      {selected && isRemovable && (
        <button className={styles.remove} onClick={handleRemove}>
          <i className="paperflite-close"></i>
        </button>
      )}
    </div>
  );
};